import { gql } from "@apollo/client";

export const GET_CATEGORIES = gql`
  query {
    getCurrentCategories {
      orderId
      startTime
      endTime
      title
      list {
        name
        slug
      }
    }
  }
`;
